module.exports = __webpack_public_path__ + "static/media/slide1.930c4d85.png";